export enum FormStateProviderActionType {
  'SET_FORM',
  'SET_FORM_ID',
  'SET_FORM_PROCEDURE',
  'SET_FORM_PROCEDURE_NAME',
  'RESET_STATE',
}
